import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import AddOnModal from './AddOnModal'
import BookNowButton from '../../ui/BookNowButton'

@observer
export default class AddOn extends React.Component {
  static propTypes = {
    addOn: PropTypes.object.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired,
    showPrice: PropTypes.bool.isRequired,
    formattedPrice: PropTypes.string,
    textColor: PropTypes.string,
    style: PropTypes.any,
    bookNowPackageId: PropTypes.number,
  }

  state = {
    showModal: false
  }

  handleShow = () => {
    this.setState({ showModal: true })
  }

  handleClose = () => {
    this.setState({ showModal: false })
  }

  renderTitle() {
    const { addOn, showPrice, formattedPrice } = this.props

    if(showPrice && formattedPrice) {
      return `${addOn.attributes.name}: ${formattedPrice}`
    }
    else {
      return addOn.attributes.name
    }
  }

  render() {
    const { addOn, style, showPrice, showBookNowButton, bookNowButtonText,
      textColor, buttonBackgroundColor, buttonForegroundColor, formattedPrice, bookNowPackageId } = this.props
    const { showModal } = this.state

    let titleStyle = {...styles.title}
    if(textColor) {
      titleStyle.color = textColor
    }

    return (
      <div style={{...styles.container, ...style}} >
        <AddOnModal
          addOn={addOn}
          showBookNowButton={showBookNowButton}
          bookNowButtonText={bookNowButtonText}
          showPrice={showPrice}
          show={showModal}
          onClose={this.handleClose}
          formattedPrice={formattedPrice}
        />
        <div onClick={this.handleShow}>
          <div style={titleStyle}>
            { this.renderTitle() }
            { " " }
            <i className="fa fa-info-circle" style={styles.info} />
          </div>
          <div>
            <img
              src={addOn.attributes.primaryImage.videoVariant}
              style={styles.image}
              loading="lazy"
            />
          </div>
        </div>
        <div style={styles.bookNowContainer}>
          <BookNowButton
            showBookNowButton={showBookNowButton}
            bookNowButtonText={bookNowButtonText}
            buttonBackgroundColor={buttonBackgroundColor}
            buttonForegroundColor={buttonForegroundColor}
            eventTypeId={bookNowPackageId}
            addOnId={addOn.id}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    cursor: 'pointer'
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
    marginBottom: 5
  },
  info: {
    fontSize: 14
  },
  image: {
    maxWidth: "100%",
    width: "auto",
    height: "auto"
  },
  bookNowContainer: {
    marginTop: 10,
    textAlign: "center"
  }
}
